import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 5px;
    padding-bottom: 10px;
  }
`;

export const SelectedButton = styled.button<{ width?: string }>`
  border-radius: 8px;
  height: 53px;
  background-color: ${({ theme }) => theme.palette.BR500};
  border: transparent;
  cursor: pointer;
  padding: 14px 24px;
  line-height: normal;
  width: ${(p) => (p.width ? p.width : 'auto')};

  @media only screen and (max-width: 1199px) {
    width: 100%;
    padding: 0;
    height: 30px;
  }
`;
export const NonSelectedButton = styled.button<{ width?: string }>`
  border-radius: 8px;
  height: 53px;
  background-color: ${({ theme }) => theme.palette.white};
  border: 1px solid ${({ theme }) => theme.palette.NL50};
  cursor: pointer;
  padding: 14px 24px;
  line-height: normal;
  width: ${(p) => (p.width ? p.width : 'auto')};
  text-wrap: nowrap;
  @media only screen and (max-width: 1199px) {
    width: 100%;
    padding: 0;
    height: 30px;
  }
`;
export const Container = styled.div`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 0px;
    margin-right: 0px;
    width: 1240px;
  }
`;
export const PackageWrapper = styled.div`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    width: 1240px;
  }
`;
export const Text = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: flex-end;
  color: ${({ theme }) => theme.palette.Blue600};
  gap: 8px;
  font-size: 16px;
  line-height: 20.11px;
`;
